import React from "react";
import SystemMailTemplateEditor from "../../components/SystemMail/SystemMailTemplateEditor";

const NewSystemMailTemplatePage: React.FC = () => {
    return <SystemMailTemplateEditor method="POST" />;
};

export default NewSystemMailTemplatePage;
